import React, { Component } from 'react';
import auth from '../modules/Auth0_setup';
import { Redirect } from "react-router-dom";
import LoadingAnimation from '../components/loading-animation';
import axios from "axios";
import { backendDomain } from "../modules/configs";

const page = {
    PRINT_DATA_PAGE: '/printData',
    PRINT_RECORD_PAGE: '/customerSupportAnaylitics',
}

export default class AuthWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountCheck: false,
            isLoading: false
        }
        this.pageUrl = window.location.pathname;
    }
    
    componentWillMount() {
        if (auth.isAuthenticated() && this.pageUrl === page.PRINT_RECORD_PAGE) {
            this.checkAccount();
        }
    }  
    
    render() {
        if (this.state.isLoading) {
            return <LoadingAnimation/>
        } 
        if (!auth.isAuthenticated()) {
            return this.pageUrl === page.PRINT_DATA_PAGE ? <Redirect to={'/printDataLogin'} /> : <Redirect to={{ pathname: '/cstLogin' }} />
        }
        if (!this.state.accountCheck && this.pageUrl === page.PRINT_RECORD_PAGE) {
            auth.logout();
            return <Redirect to={{
                pathname: '/cstLogin',
                state: { errorMessage: 'Account verification failed, no permission' }
            }} />
        }
        return this.props.children;
    }

    checkAccount() {
        this.startVerifyingAccount();
        axios.get(`${backendDomain}/record/accountCheck`, { headers: { Authorization: `Bearer ${localStorage.access_token}` } }).then(res => {
            this.accountVerificationComplete(true);
        }).catch(err => {
            this.accountVerificationComplete(false);
        })
    }

    startVerifyingAccount() {
        this.setState({
            isLoading: true
        })
    }

    accountVerificationComplete(accountCheck) {
        this.setState({
            accountCheck: accountCheck,
            isLoading: false
        })
    }
}


// WEBPACK FOOTER //
// ./src/components/authWrapper.js